import when from 'when';

export const FORM_SUBMIT = 'takeback/FORM_SUBMIT';

/* Actions */
export function submitForm(submitAction, successAction, failureAction, values, resolve, reject) {
    return {
        type: FORM_SUBMIT,
        payload: {
            submitAction,
            successAction,
            failureAction,
            values,
            resolve,
            reject,
        },
    };
}

export function createSubmitAction(submitAction, successAction, failureAction, callback = null) {
    return (values, dispatch) => (
        when.promise((resolve, reject) => {
            dispatch(
                submitForm(
                    submitAction,
                    successAction,
                    failureAction,
                    values,
                    resolve,
                    reject
                )
            );
            callback && callback(values);
        })
    );
}
